import { createAction } from "redux-actions";

export const showInfoMessage = createAction("SHOW_INFO_MESSAGE_SUCCESS");
export const clearInfoMessage = createAction("CLEAR_INFO_MESSAGE_SUCCESS");
